import React, { forwardRef } from 'react';

import classNames from 'classnames';

import styles from './Input.module.scss';

export interface SpInputProps {
    value: string;
    onChange: (value: string) => void | Promise<void>;
    className?: string;
    autoComplete?: string;
    placeholder?: string;
    type?: string;
    required?: boolean;
    disabled?: boolean;
    onKeyDown?: (event: React.KeyboardEvent) => void;
    'data-testid'?: string;
}

const SpInput = forwardRef<HTMLInputElement, SpInputProps>(({
    value,
    onChange,
    className = '',
    type = 'text',
    placeholder = '',
    autoComplete = '',
    required = false,
    disabled = false,
    onKeyDown,
    'data-testid': testId,
}, ref) => {
    const wrapperClasses = classNames(styles['input-container'], { [className]: !!className });

    return (
        <div className={wrapperClasses}>
            <input
                /*
                 * `key` is intentionally tied to the placeholder text. Some browsers (notably
                 * Chrome/Safari) do not visually repaint the placeholder when only the
                 * `placeholder` attribute is updated mid-life — for example after an i18n
                 * language switch that also flips `document.documentElement.dir`. Re-keying
                 * forces React to remount the input so the new placeholder is rendered fresh.
                 */
                key={placeholder}
                data-testid={testId}
                ref={ref}
                placeholder={placeholder}
                disabled={disabled}
                value={value}
                type={type}
                required={required}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                autoComplete={autoComplete}
            />
            <span className={styles.hide}>Error message</span>
        </div>
    );
});

SpInput.displayName = 'SpInput';

export default SpInput;
